import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { FilterInduccionPorVencerModel } from 'src/app/models/induccion/FilterInduccionPorVencerModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { InduccionReprogramarModel } from 'src/app/models/induccion/InduccionModel';
import { IAccesoPorVencerResult } from 'src/app/models/interfaces/accesos/IAccesoPorVencerResult';
import { IInduccionResultadoBusquedaModel } from 'src/app/models/queries/inducciones/interfaces/IInduccionResultadoBusquedaModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { SedeService } from 'src/app/services/sede/sede.service';
import { InduccionReprogramarDialogComponent } from '../../induccion/induccion-reprogramar-dialog/induccion-reprogramar-dialog/induccion-reprogramar-dialog.component';
import * as fileSaver from 'file-saver';
import { InduccionService } from 'src/app/services/induccion/induccion.service';
import { IFilterInduccionPorVencerModel } from 'src/app/models/interfaces/induccion/IFilterInduccionPorVencerModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-accesos-por-vencer-lista',
  templateUrl: './accesos-por-vencer-lista.component.html',
  styleUrls: ['./accesos-por-vencer-lista.component.css']
})
export class AccesosPorVencerListaComponent implements OnInit {
  listaSedes: ISedeModel[];
  modelFilter: IFilterInduccionPorVencerModel
  modelListaInducciones: IInduccionResultadoBusquedaModel[];
  resultsLength = 0;
  currentPage = 0;
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();

  @ViewChild('paginator') paginator!: MatPaginator;

  displayedColumns: string[] = [
    'compania',
    'trabajador',
    'nroDocumentoIdentidad',
    'fechaAprobacion',
    'fechaVencimiento',
    'sede',
    // 'solicitante',
    'contratista',
    // 'codigo',
    'acciones',
  ];

  constructor(
    private sedeService: SedeService,
    private induccionService: InduccionService,
    public dialog: MatDialog,
    private storage: StorageService,
  ) {
    this.modelFilter = new FilterInduccionPorVencerModel();
    this.modelFilter.pageSize = 30;
    //No se asignan fechas para la bandeja
    // this.modelFilter.fechaInicio = new Date();
    // this.modelFilter.fechaFin = this.addMonths(new Date(), 2);
    this.modelListaInducciones = new Array<IInduccionResultadoBusquedaModel>();
    this.listaSedes = new Array<SedeModel>();
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.modelFilter.idCompania = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {
    this.companiaChanged();

    this.search();
  }

  companiaChanged() {

    this.listaSedes = [];
    this.modelFilter.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.modelFilter.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  search(): void {
    this.modelFilter.page = 1;
    this.induccionService
      .getListPorVencer(this.modelFilter)
      .subscribe((data: SearchResultModel<IInduccionResultadoBusquedaModel[]>) => {
        this.modelListaInducciones = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.modelFilter.page = event.pageIndex + 1;
    this.modelFilter.pageSize = event.pageSize;
    this.induccionService
      .getListPorVencer(this.modelFilter)
      .subscribe(
        (data: SearchResultModel<IInduccionResultadoBusquedaModel[]>) => {
          this.modelListaInducciones = data.items;
          this.resultsLength = data.total;
        }
      );
  }

  reprogramarInduccion(): void {
    let reprogramacionInducciones = new InduccionReprogramarModel();
    reprogramacionInducciones.listaInducciones = this.modelListaInducciones.filter(p => p.programarInduccion).map(a => a.idInduccion);
    const dialogRef = this.dialog.open(InduccionReprogramarDialogComponent, {
      width: '500px',
      // data: { name: this.name, animal: this.animal}
      data: reprogramacionInducciones
    });

    dialogRef.afterClosed().subscribe(result => {
      this.search();
    });
  }

  addDays(currentDate: Date, days: number): Date {
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }

  addMonths(currentDate: Date, months: number): Date {
    currentDate.setMonth(currentDate.getMonth() + months);
    return currentDate;
  }

  keyPressNumberOnly(event: any) {
    const pattern = /^[0-9]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  export() {
    //this.paginator.pageIndex = 0;
    this.modelFilter.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.induccionService.getListPorVencerToExport(this.modelFilter).subscribe(
      (data) => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);

        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `inducciones-por-vencer-${Date.now()}.xlsx`);

        //  this.createImageFromBlob(data);
        //  this.isImageLoading = false;
      },
      (error) => {
        //  this.isImageLoading = false;
        //  console.log(error);
      }
    );
  }
}
